import { ROLE } from '../../../../types';

export interface INotification {
  titleId: string;
  title?: string;
  messageId: string;
  message?: string;
  isRead?: boolean;
}

export type NotificationMessageKey = `${ROLE}` | 'GENERAL';

const notificationMessageMap: Partial<Record<NotificationMessageKey, INotification[]>> = {
  [ROLE.ROLE_ADMIN]: [],
  [ROLE.ROLE_MAPAQ]: [],
  [ROLE.ROLE_MAPAQ_RO]: [],
  [ROLE.ROLE_SUPPORT]: [],
  [ROLE.ROLE_DETENTEUR_PERMIS]: [
    {
      titleId: 'notificationMessage.title_0',
      messageId: 'notificationMessage.message_0',
    },
    {
      titleId: 'notificationMessage.title_1',
      messageId: 'notificationMessage.message_1',
    },
    {
      titleId: 'notificationMessage.title_2',
      messageId: 'notificationMessage.message_2',
    },
  ],
  [ROLE.ROLE_VET]: [],
  [ROLE.ROLE_FMV]: [],
  [ROLE.ROLE_PRODUCER]: [],
  [ROLE.ROLE_ASSOCIATION]: [],
  GENERAL: [],
};

export default notificationMessageMap;
